<template>
  <AppLayout>
    <div class="home">
      <section id="settings-categories">
        <div class="container">
          <h6 class="mb-2 fw-bold">User Profile</h6>

          <div class="row">
            <div class="col-lg-4">
              <div class="card mb-4">
                <div class="card-body text-center">
                  <img
                    v-if="user.picture"
                    :src="user.picture"
                    alt="avatar"
                    class="rounded-circle img-fluid"
                    style="width: 150px;"
                  />
                  <img
                    v-else
                    src="https://th.bing.com/th/id/OIP.tQYFfqM9HEki3rZPgBodgQAAAA?rs=1&pid=ImgDetMain"
                    alt="avatar"
                    class="rounded-circle img-fluid"
                    style="width: 150px;"
                  />

                  <h5 class="my-3">{{ user.name }}</h5>
                  <p class="text-muted mb-4 text-capitalize">{{ user?.Permission?.name }}</p>

                  <div class="d-flex justify-content-center mb-2">
                    <button
                      type="button"
                      class="btn btn-primary"
                      :disabled="saving"
                      @click="updateProfile"
                    >
                      <span v-if="!saving">Update Profile</span>
                      <span v-else>Saving...</span>
                    </button>
                  </div>

                  <div style="margin-top:12px; text-align:left; width:100%">
                    <label class="mb-1 text-primary">Signature</label>
                    <div class="d-flex align-items-center" style="gap:12px;">
                      <div>
                        <input type="file" accept="image/*" @change="onSignatureChange" />
                      </div>
                      <div v-if="signaturePreview || user.signature">
                        <img
                          :src="signaturePreview || (user.signature ? (urlServer + '/files/' + user.signature) : '')"
                          alt="signature"
                          style="height:48px;"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-8">
              <div class="card mb-4">
                <div class="card-body">
                  <div class="row mb-2">
                    <div class="col-sm-3">
                      <p class="mb-0 text-primary">Full Name</p>
                    </div>
                    <div class="col-sm-9">
                      <input type="text" class="text-muted mb-0" v-model="name" />
                    </div>
                  </div>

                  <hr />

                  <div class="row mb-2">
                    <div class="col-sm-3">
                      <p class="mb-0 text-primary">Email</p>
                    </div>
                    <div class="col-sm-9">
                      <input type="email" class="text-muted mb-0" v-model="email" />
                    </div>
                  </div>

                  <hr />

                  <div class="row mb-2">
                    <div class="col-sm-3">
                      <p class="mb-0 text-primary">Phone 1</p>
                    </div>
                    <div class="col-sm-9">
                      <input type="tel" class="text-muted mb-0" v-model="phone" />
                    </div>
                  </div>

                  <hr />

                  <div class="row mb-2">
                    <div class="col-sm-3">
                      <p class="mb-0 text-primary">Phone 2</p>
                    </div>
                    <div class="col-sm-9">
                      <input type="tel" class="text-muted mb-0" v-model="phone2" />
                    </div>
                  </div>

                  <hr />

                  <div class="row">
                    <div class="col-sm-3">
                      <p class="mb-0 text-primary">System Role</p>
                    </div>
                    <div class="col-sm-9">
                      <p class="text-muted mb-0 text-capitalize">{{ user?.Permission?.name }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from '../../components/AppLayout.vue'

export default {
  name: 'UserProfileView',
  components: { AppLayout },
  data() {
    return {
      token: JSON.parse(localStorage.getItem('access_token')),
      urlServer: process.env.VUE_APP_URL,
      user: {},
      name: '',
      email: '',
      phone: '',
      phone2: '',
      designation: '',
      roleId: 1,
      employeeId: '',
      isSystemUser: true,
      picture: '',
      upload: null,
      uploadSignature: null,
      signaturePreview: '',
      saving: false
    }
  },
  mounted() {
    this.setupUser()
  },
  methods: {
    async setupUser() {
      try {
        const requestOptions = { method: 'GET', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.token } }
        const res = await fetch(process.env.VUE_APP_URL + '/users/profile', requestOptions)
        const data = await res.json()
        if (data.status === true) {
          this.user = data.user
          this.name = this.user.name || ''
          this.email = this.user.email || ''
          this.phone = this.user.phone || ''
          this.phone2 = this.user.phone2 || ''
          this.designation = this.user.designation || ''
        } else {
          this.$router.push('/')
        }
      } catch (err) {
        console.error('Failed to fetch profile', err)
      }
    },

    onSignatureChange(e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return
      this.uploadSignature = file
      try {
        this.signaturePreview = URL.createObjectURL(file)
      } catch (err) {
        this.signaturePreview = ''
      }
    },

    async updateProfile() {
      this.saving = true
      try {
        if (!this.token) {
          if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error('Not authenticated')
          this.saving = false
          return
        }
        if (!this.user || !this.user.id) {
          if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error('User not loaded')
          this.saving = false
          return
        }

        const formData = new FormData()
        formData.append('name', this.name)
        if (this.upload) formData.append('upload', this.upload)
        formData.append('picture', this.picture)
        if (this.uploadSignature) formData.append('signature', this.uploadSignature)
        formData.append('designation', this.designation)
        formData.append('employeeId', this.employeeId)
        formData.append('isSystemUser', this.isSystemUser)
        formData.append('roleId', this.roleId)
        formData.append('email', this.email)
        formData.append('phone', this.phone)
        formData.append('phone2', this.phone2)

        const requestOptions = {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + this.token
          },
          body: formData
        }

        // Debug: log formData keys
        try {
          for (const pair of formData.entries()) {
            // eslint-disable-next-line no-console
            console.log('formData', pair[0], pair[1])
          }
        } catch (e) {
          // ignore
        }

        if (this.$toast && typeof this.$toast.info === 'function') this.$toast.info('Saving profile...')
        const response = await fetch(process.env.VUE_APP_URL + '/users/' + this.user.id, requestOptions)
        const body = await response.text()
        // eslint-disable-next-line no-console
        console.log('updateProfile response', response.status, body)
        if (response?.status === 200) {
          if (this.$toast && typeof this.$toast.success === 'function') this.$toast.success('Profile updated')
          window.location.reload()
        } else {
          if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error('Failed to update user')
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error updating user:', error)
        if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error('Failed to update user: ' + (error?.message || ''))
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
input {
  border: none;
  padding: 3px 5px;
  outline: none;
}
input:focus {
  border-bottom: 0.5px solid grey;
}
</style>